import React from "react";
import ListOfficalStores from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/products/ListOfficalStores";
import Card from "react-bootstrap/Card";

export default function ViewsBeforeToSend() {

  return (
    <div style={{ width: "100%", padding: "40px" }}>
      <ListOfficalStores.ContListProd>
        <Card className="shadow-sm">
          <Card.Body style={{
            textAlign: "center",
            padding: "30px",
            backgroundColor: "#f8f9fa"
          }}>
            <img 
              src="https://sellercenter.falabella.com/assets/img/header-logo-fsc-2025.svg" 
              alt="Falabella Logo"
              style={{ 
                width: "120px",
                marginBottom: "20px"
              }}
            />
            <h4 style={{ 
              fontSize: "18px",
              color: "#2c3e50",
              marginBottom: "15px"
            }}>
              Al hacer clic en "Publicar", tus productos se publicarán en Falabella
            </h4>
            <p style={{
              color: "#6c757d",
              fontSize: "14px",
              margin: 0
            }}>
              Si tienes alguna vpn activa, por favor desactivala para que no de error al publicar tus productos
            </p>
          </Card.Body>
        </Card>
      </ListOfficalStores.ContListProd>
    </div>
  );
}
